import { createTheme } from '@mui/material/styles';

// Define custom theme
const theme = createTheme({
    palette: {
        primary: {
            main: '#27ae60',
        },
        secondary: {
            main: '#3c3c3c',
        },
        grey: {
            main: '#7f8c8d',
        },
        grey2: {
            main: '#cbcbdb',
        },
        black: {
            main: '#000000',
        },
        lightBlack: {
            main: '#414141',
        },
        purple: {
            main: '#8e44ad',
        },
        lightPurple: {
            main: '#a392db',
        },
        yellow: {
            main: '#f0c258',
        },
        blue: {
            main: '#2196F3',
        },
        white: {
            main: "#FFFFFF"
        },
        lightWhite: {
            main: "#f6f8fa"
        },
        lightRed: {
            main: "#eb9292"
        },
        lightGreen: {
            main: "#65c09a"
        },
        carrot: {
            main: "#eb9292"
        },
        error: {
            main: '#e74c3c',
        },
        warning: {
            main: '#f39c12',
        },
        info: {
            main: '#2ecc71',
        },
        success: {
            main: '#1abc9c',
        },
    },
    typography: {
        body1: {
            lineHeight: 1.6,
            fontSize: 14,
            fontWeight: 400,
        },
        body2: {
            lineHeight: 1.6,
            fontSize: 14,
            fontWeight: 600,
        },
        subtitle1: {
            lineHeight: 1.6,
            fontSize: 16,
            fontWeight: 400,
        },
        subtitle2: {
            lineHeight: 1.6,
            fontSize: 16,
            fontWeight: 600,
        },
        fontFamily: [
            'Poppins',
            'sans-serif',
        ].join(','),
    },
});

export default theme;
